import React from 'react';
import { SvgProps } from './icon.types';

function CommentsNumberIcon({ fillColor = '#2D3049', title, ...props }: SvgProps) {
  return (
    <svg version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M22 3v15h-8l-2 3-2-3H2V3h20zm-2 2H4v11h7.07l.93 1.395.93-1.395H20V5zm-7 6v2H7v-2h6zm4-3v2H7V8h10z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { CommentsNumberIcon };
